import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  text-align: left !important;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 146px;
  height: 30px;
  cursor: pointer;
  clear: both;
  border-radius: 28px;
  padding: 5px 10px 5px 5px;
  color: #797979;
  margin-right: 10px;

  @media (max-width: 900px) {
    margin-left: 30px;
  }

  > span {
    vertical-align: middle;
    display: flex;
    margin-left: 5px;
    font-style: normal;
    font-weight: normal;
    font-family: Basier Circle;
    font-size: 11px;
    line-height: 16px;
    letter-spacing: -0.2px;
  }
  > a {
    display: flex;
    text-decoration: none !important;
    color: black !important;
  }
  > .add-menu-item {
    vertical-align: middle;
  }
`;

function Joined(props) {
  return (
    <Container onClick={props.onClick}>
      <span>{props.children}</span>
    </Container>
  );
}

export default Joined;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/Joined/index.jsx